var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-auto items-center"},[_c('app-icon',{class:_vm.styles,attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.withLabel)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }